/** Wire format abstraction: JSON now, binary later without touching the simulation. */
export interface Codec {
  encode(msg: unknown): string | Uint8Array;
  decode(data: string | ArrayBuffer | Uint8Array): unknown;
}

export const JsonCodec: Codec = {
  encode(msg) {
    return JSON.stringify(msg);
  },
  decode(data) {
    if (typeof data === 'string') return JSON.parse(data);
    const text = new TextDecoder().decode(data instanceof Uint8Array ? data : new Uint8Array(data));
    return JSON.parse(text);
  },
};
